import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { MenuConfig } from '@repo/utils';
import { type Role } from './constants';

export type MENU_KEYS = 'ADMIN_USERS' | 'PROFILE' | 'GENERATE_QR';

export const menuConfig: MenuConfig<MENU_KEYS, Role>[] = [
  {
    key: 'ADMIN_USERS',
    label: 'User Management',
    to: '/admin/users',
    icon: <PeopleIcon />,
    permissions: [],
  },
  {
    key: 'PROFILE',
    label: 'My Profile',
    to: '/profile',
    icon: <PersonIcon />,
    permissions: [],
  },
  {
    key: 'GENERATE_QR',
    label: 'Invite via QR',
    to: '/fast-signup/generate-qr',
    icon: <QrCode2Icon />,
    permissions: [],
  },
];
